"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const ShakaRobustness = {
  MANIFEST_RETRY_ATTEMPTS: 2,
  MANIFEST_RETRY_INTERVAL: 1e3,
  // NOTE: Shaka's maxAttempts parameter includes the initial failed attempt, so if the desired goal is to perform 3 retries, this should be set to 4
  FATAL_ERROR_RECOVERY_ATTEMPTS: 4,
  FATAL_ERROR_RECOVERY_DELAY: 1e3,
  FATAL_ERROR_RECOVERY_BACKOFF: 2,
  FATAL_ERROR_RECOVERY_FUZZ: 0
};
const escapedHtml = /&(?:amp|lt|gt|quot|apos|nbsp|lrm|rlm|#[xX]?[0-9a-fA-F]+);/g;
function unescapeHtml(text) {
  if (text.indexOf("&") === -1) return text;
  return text.replace(escapedHtml, (match) => {
    switch (match) {
      case "&amp;":
        return "&";
      case "&lt;":
        return "<";
      case "&gt;":
        return ">";
      case "&quot;":
        return '"';
      case "&apos;":
        return "'";
      case "&nbsp;":
        return " ";
      case "&lrm;":
        return "‎";
      case "&rlm;":
        return "‏";
      default:
        if (match[1] === "#") {
          const code = match[2] === "x" || match[2] === "X" ? parseInt(match.slice(3), 16) : parseInt(match.slice(2), 10);
          return String.fromCodePoint(code);
        }
        return match;
    }
  });
}
function getElementsByName(node, name, found = []) {
  if (!node) return found;
  if (node.nodeName === name) found.push(node);
  if (node.childNodes) for (const child of node.childNodes) getElementsByName(child, name, found);
  return found;
}
function parseXml(input, options = {}) {
  let pos = options.pos || 0;
  const length = input.length;
  const keepComments = !!options.keepComments;
  const keepWhitespace = !!options.keepWhitespace;
  const openBracket = "<";
  const openBracketCC = "<".charCodeAt(0);
  const closeBracket = ">";
  const closeBracketCC = ">".charCodeAt(0);
  const minusCC = "-".charCodeAt(0);
  const slashCC = "/".charCodeAt(0);
  const questionCC = "?".charCodeAt(0);
  const exclamationCC = "!".charCodeAt(0);
  const singleQuoteCC = "'".charCodeAt(0);
  const doubleQuoteCC = '"'.charCodeAt(0);
  const openCornerBracketCC = "[".charCodeAt(0);
  const closeCornerBracketCC = "]".charCodeAt(0);
  const nameSpacer = "\r\n	>/= ";
  function createTextNode(value, nodeName = "#text") {
    return {
      nodeName,
      nodeValue: value,
      attributes: {},
      childNodes: []
    };
  }
  function parseChildren(tagName = "") {
    const children = [];
    while (input[pos]) if (input.charCodeAt(pos) == openBracketCC) {
      if (input.charCodeAt(pos + 1) === slashCC) {
        const closeStart = pos + 2;
        pos = input.indexOf(closeBracket, pos);
        if (!input.startsWith(tagName, closeStart)) {
          const parsedText = input.substring(0, pos).split("\n");
          throw new Error("Unexpected close tag\nLine: " + (parsedText.length - 1) + "\nColumn: " + (parsedText[parsedText.length - 1].length + 1) + "\nChar: " + input[pos]);
        }
        if (pos + 1) pos += 1;
        return children;
      } else if (input.charCodeAt(pos + 1) === questionCC) {
        pos = input.indexOf(closeBracket, pos);
        pos++;
        continue;
      } else if (input.charCodeAt(pos + 1) === exclamationCC) {
        if (input.charCodeAt(pos + 2) == minusCC) {
          const startCommentPos = pos;
          while (pos !== -1 && !(input.charCodeAt(pos) === closeBracketCC && input.charCodeAt(pos - 1) == minusCC && input.charCodeAt(pos - 2) == minusCC && pos != -1)) pos = input.indexOf(closeBracket, pos + 1);
          if (pos === -1) pos = length;
          if (keepComments) children.push(createTextNode(input.substring(startCommentPos, pos + 1), "#comment"));
        } else if (input.charCodeAt(pos + 2) === openCornerBracketCC && input.charCodeAt(pos + 8) === openCornerBracketCC && input.startsWith("CDATA", pos + 3)) {
          const cdataEndIndex = input.indexOf("]]>", pos);
          if (cdataEndIndex == -1) {
            children.push(createTextNode(input.substr(pos + 9), "#cdata"));
            pos = length;
          } else {
            children.push(createTextNode(input.substring(pos + 9, cdataEndIndex), "#cdata"));
            pos = cdataEndIndex + 3;
          }
          continue;
        } else {
          const startDoctype = pos + 1;
          pos += 2;
          let encapsuled = false;
          while ((input.charCodeAt(pos) !== closeBracketCC || encapsuled === true) && input[pos]) {
            if (input.charCodeAt(pos) === openCornerBracketCC) encapsuled = true;
            else if (encapsuled === true && input.charCodeAt(pos) === closeCornerBracketCC) encapsuled = false;
            pos++;
          }
          children.push(createTextNode(input.substring(startDoctype, pos), "#doctype"));
        }
        pos++;
        continue;
      }
      const node = parseNode();
      children.push(node);
    } else {
      const text = parseText();
      if (keepWhitespace) {
        if (text.length > 0) children.push(createTextNode(text));
      } else {
        const trimmed = text.trim();
        if (trimmed.length > 0) children.push(createTextNode(trimmed));
      }
      pos++;
    }
    return children;
  }
  function parseText() {
    const start = pos;
    pos = input.indexOf(openBracket, pos) - 1;
    if (pos === -2) pos = length;
    return unescapeHtml(input.slice(start, pos + 1));
  }
  function parseName() {
    const start = pos;
    while (nameSpacer.indexOf(input[pos]) === -1 && input[pos]) pos++;
    return input.slice(start, pos);
  }
  function parseAttributes() {
    const attributes = {};
    while (input.charCodeAt(pos) !== closeBracketCC && input[pos]) {
      const c = input.charCodeAt(pos);
      if (c > 64 && c < 91 || c > 96 && c < 123) {
        const name = parseName();
        let value = "";
        let code = input.charCodeAt(pos);
        while (code !== singleQuoteCC && code !== doubleQuoteCC) {
          pos++;
          code = input.charCodeAt(pos);
        }
        if (code === singleQuoteCC || code === doubleQuoteCC) {
          value = parseString();
          if (pos === -1) throw new Error("Missing closing quote");
        } else pos--;
        attributes[name] = unescapeHtml(value);
      }
      pos++;
    }
    return attributes;
  }
  function parseNode() {
    pos++;
    const nodeName = parseName();
    let localName = nodeName;
    let prefix = null;
    const nsIndex = nodeName.indexOf(":");
    if (nsIndex !== -1) {
      prefix = nodeName.slice(0, nsIndex);
      localName = nodeName.slice(nsIndex + 1);
    }
    const attributes = parseAttributes();
    let childNodes = [];
    const prev = input.charCodeAt(pos - 1);
    pos++;
    if (prev !== slashCC) childNodes = parseChildren(nodeName);
    return {
      nodeName,
      nodeValue: null,
      attributes,
      childNodes,
      prefix,
      localName
    };
  }
  function parseString() {
    const startChar = input[pos];
    const startpos = pos + 1;
    pos = input.indexOf(startChar, startpos);
    return input.slice(startpos, pos);
  }
  return {
    nodeName: "#document",
    nodeValue: null,
    childNodes: parseChildren(""),
    attributes: {}
  };
}
function getEarlyTimelineEvents(response) {
  let xml;
  try {
    xml = parseXml(response);
  } catch (e) {
    return null;
  }
  const mpd = findNodeByName(xml.childNodes, "MPD");
  const { attributes } = mpd;
  if (attributes.type === "static") {
    const p1 = findNodeByName(mpd.childNodes, "Period");
    if (p1) {
      const events = findNodeByName(p1.childNodes, "EventStream");
      return events ? parseEventStream(events) : null;
    }
    return null;
  }
  return null;
}
function parseEventStream(node) {
  const timescale = parseInt(node.attributes.timescale);
  const schemeIdUri = node.attributes.schemeIdUri;
  if (!timescale || isNaN(timescale) || !schemeIdUri) {
    this.logger.info("shaka adapter encountered invalid EventStream node.");
    return null;
  }
  return node.childNodes.filter((n) => {
    const t = parseInt(n.attributes.presentationTime) / timescale;
    return n.nodeName === "Event" && t < 1;
  }).map((n) => parseEvent(n, timescale, schemeIdUri));
}
function parseEvent(node, timescale, schemeIdUri) {
  const { duration, messageData, presentationTime } = node.attributes;
  const pts = parseInt(presentationTime) || 0;
  const data = messageData || "";
  const startTime = pts / timescale;
  return {
    id: schemeIdUri,
    info: data,
    text: data,
    data,
    source: {},
    startTime,
    endTime: startTime + parseFloat(duration)
  };
}
function findNodeByName(nodes, name) {
  return nodes.find((n) => n.nodeName === name);
}
const MPD = "MPD";
const STATIC = "static";
const REPRESENTATION = "Representation";
const ADAPTATION_SET = "AdaptationSet";
const HEV = "hev";
const HVC = "hvc";
function serializeXml(xml) {
  const { nodeName, attributes, childNodes } = xml;
  if (nodeName === "#document") {
    return `<?xml version="1.0" encoding="UTF-8"?>${serializeXml(childNodes[0])}`;
  }
  if (nodeName === "#text") {
    return xml.nodeValue || "";
  }
  let result = `<${nodeName}`;
  if (attributes) {
    for (const key in attributes) {
      result += ` ${key}=${JSON.stringify(attributes[key])}`;
    }
  }
  let children = "";
  for (let i = 0, l = childNodes.length; i < l; i++) {
    children += serializeXml(childNodes[i]);
  }
  const close = !children ? " />" : `>${children}</${nodeName}>`;
  result += close;
  return result;
}
function normalizeHevcCodecs(xml) {
  const parsedXml = parseXml(xml);
  const mpdNodes = getElementsByName(parsedXml, MPD);
  const mpdNode = mpdNodes[0];
  const mpdType = mpdNode ? mpdNode.attributes.type : null;
  if (mpdType !== STATIC) {
    return xml;
  }
  const codecNodes = [...getElementsByName(parsedXml, REPRESENTATION), ...getElementsByName(parsedXml, ADAPTATION_SET)];
  codecNodes.forEach((node) => {
    const codec = node.attributes.codecs;
    if (codec == null ? void 0 : codec.includes(HEV)) {
      node.attributes.codecs = codec.replace(HEV, HVC);
    }
  });
  return serializeXml(parsedXml);
}
const SHAKA = "shaka";
const DEFAULT_SAFE_MARGIN = 2;
function isShakaSupported(context) {
  const { avia } = context;
  const { MimeType, PlaybackAdapterBase } = avia;
  return PlaybackAdapterBase.canPlay(context, [MimeType.DASH]);
}
function createShakaAdapter(context, options) {
  return __async(this, null, function* () {
    var _a;
    const { avia, resource, system, textTrackSettings, playerOptions } = context;
    const { playback } = resource;
    const { startTime } = playback;
    const { AudioTrackType, DrmType, ErrorCode, LogLevel, MimeType, PlaybackAdapterBase, PlayerError, Util } = avia;
    if (!system.global.shaka) {
      try {
        const debug = options.debug ? ".debug" : "";
        yield Util.loadScript(
          { url: ((_a = options.dependencies) == null ? void 0 : _a.shaka) || `//cdn.jsdelivr.net/npm/shaka-player@4.16.24/dist/shaka-player.compiled${debug}.js` },
          playerOptions,
          () => {
            return system.global.shaka;
          }
        );
      } catch (error) {
        throw new PlayerError(ErrorCode.SHAKA_SDK_MISSING, "Could not load Shaka Player SDK", error);
      }
    }
    const {
      ErrorMessage,
      Header,
      PlayerHookType,
      PerformanceMode,
      RequestObjectType,
      TextTrackKind
    } = avia;
    const shaka2 = system.global.shaka;
    const isActive = (track) => track.active;
    const equal = (a, b) => JSON.stringify(a) === JSON.stringify(b);
    const isUnd = (track) => (track == null ? void 0 : track.language) === "und";
    class ShakaAdapter extends PlaybackAdapterBase {
      /**
       * ShakaAdapter
       */
      constructor(context2, options2 = {}) {
        var _a2, _b, _c;
        super(context2, options2, false);
        this.cachedCuepoints = null;
        this.cleanUpVtt = false;
        this.isLiveStream = false;
        this.renderTextTrackNatively = true;
        this.domTextTrack = null;
        this.audioSwitching = false;
        this.playerEventMap = {
          error: (event) => this.onError(event),
          streaming: () => this.onStreaming(),
          variantchanged: () => this.onVariantChanged(),
          adaptation: () => this.onVariantChanged(),
          manifestupdated: (event) => this.onManifestUpdated(event),
          emsg: (event) => this.onEmsg(event),
          metadata: (event) => this.onMetadata(event),
          trackschanged: Util.debounce(() => this.onTracksChanged(), 25),
          drmsessionupdate: () => this.onDrmSessionUpdate(),
          timelineregionenter: (event) => this.onTimelineRegionEnter(event)
        };
        this.responseHook = (context22) => {
          if (context22.metadata.objectType !== RequestObjectType.MANIFEST || this.isLiveStream) {
            return;
          }
          try {
            context22.value.data = normalizeHevcCodecs(context22.value.data);
          } catch (error) {
            this.logger.warn("Unable to update HEVC codecs in manifest.");
          }
        };
        this.onRequest = (type, request) => {
          var _a3, _b2;
          const drm = this.context.resource.location.drm;
          if (type === shaka2.net.NetworkingEngine.RequestType.LICENSE) {
            if ((_a3 = drm.widevine) == null ? void 0 : _a3.header) {
              Object.assign(request.headers, drm.widevine.header);
            }
            if ((_b2 = drm.playready) == null ? void 0 : _b2.header) {
              Object.assign(request.headers, drm.playready.header);
            }
          }
        };
        this.onResponse = (type, response) => {
          const cdn = response.headers[Header.MULTI_CDN];
          if (cdn != null) {
            this.delegate.cdnChange(cdn);
          }
        };
        this.onManifest = (type, response) => {
          const isHls = response.uri.includes(".m3u8");
          const isManifest = type === shaka2.net.NetworkingEngine.RequestType.MANIFEST;
          if (isManifest && !isHls) {
            const str = this.context.avia.Util.bufferToString(response.data);
            this.cachedCuepoints = getEarlyTimelineEvents(str);
            this.player.getNetworkingEngine().unregisterResponseFilter(this.onManifest);
          }
        };
        let margin = (_a2 = options2.safeMargin) != null ? _a2 : DEFAULT_SAFE_MARGIN;
        if (!Number.isFinite(margin) || margin < 0) {
          margin = DEFAULT_SAFE_MARGIN;
        }
        this.safeMargin = margin;
        if (options2.debounceTracksChanged === false) {
          this.playerEventMap.trackschanged = () => {
            clearTimeout(this.tracksChangedTimeout);
            this.tracksChangedTimeout = setTimeout(() => this.onTracksChanged(), 25);
          };
        }
        this.logger.info(`Shaka Player version: ${shaka2.Player.version}`);
        if (typeof VTTCue === "undefined") {
          this.cleanUpVtt = true;
        }
        shaka2.polyfill.installAll();
        const Level = (_b = shaka2.log) == null ? void 0 : _b.Level;
        if (options2.logLevel && Level) {
          let shakaLogLevel;
          switch (options2.logLevel) {
            case LogLevel.OFF:
              shakaLogLevel = Level.OFF;
              break;
            case LogLevel.ERROR:
              shakaLogLevel = Level.ERROR;
              break;
            case LogLevel.WARN:
              shakaLogLevel = Level.WARNING;
              break;
            case LogLevel.INFO:
              shakaLogLevel = Level.INFO;
              break;
            case LogLevel.DEBUG:
              shakaLogLevel = Level.DEBUG;
              break;
            case LogLevel.VERBOSE:
              shakaLogLevel = Level.V1;
              break;
          }
          shaka2.log.setLevel(shakaLogLevel);
        }
        this.player = new shaka2.Player();
        this.player.attach(this.video);
        const playerConfig = this.playerConfig = this.player.getConfiguration();
        this.addEvents(this.player, this.playerEventMap);
        let retry = this.playerConfig.streaming.retryParameters;
        retry.maxAttempts = ShakaRobustness.FATAL_ERROR_RECOVERY_ATTEMPTS;
        retry.baseDelay = ShakaRobustness.FATAL_ERROR_RECOVERY_DELAY;
        retry.backoffFactor = ShakaRobustness.FATAL_ERROR_RECOVERY_BACKOFF;
        retry.fuzzFactor = ShakaRobustness.FATAL_ERROR_RECOVERY_FUZZ;
        retry = this.playerConfig.manifest.retryParameters;
        retry.maxAttempts = ShakaRobustness.MANIFEST_RETRY_ATTEMPTS;
        retry.baseDelay = ShakaRobustness.MANIFEST_RETRY_INTERVAL;
        const networkEngine = this.player.getNetworkingEngine();
        networkEngine.registerRequestFilter(this.onRequest);
        networkEngine.registerResponseFilter(this.onResponse);
        if (!options2.skipEventStreamParsing && (startTime === 0 || !Util.isValidPlayheadTime(startTime))) {
          networkEngine.registerResponseFilter(this.onManifest);
        }
        const { playready, widevine } = resource.location.drm;
        const { PLAYREADY, WIDEVINE } = DrmType;
        const configureDrm = (drm, dfltSystem) => {
          const { keySystem: system2 = dfltSystem } = drm;
          if (drm == null ? void 0 : drm.url) {
            playerConfig.drm.servers[system2] = drm.url;
            playerConfig.drm.advanced[system2] = {};
            if (drm.audioRobustness) {
              playerConfig.drm.advanced[system2].audioRobustness = drm.audioRobustness;
            }
            if (drm.videoRobustness) {
              playerConfig.drm.advanced[system2].videoRobustness = drm.videoRobustness;
            }
            playerConfig.drm.preferredKeySystems.push([system2, drm.priority]);
          }
        };
        configureDrm(widevine, WIDEVINE);
        configureDrm(playready, PLAYREADY);
        playerConfig.drm.preferredKeySystems = this.playerConfig.drm.preferredKeySystems.sort((a, b) => a[1] - b[1]).map((i) => i[0]);
        const abrConfig = playback.abr;
        const { restrictions, abr } = this.playerConfig;
        if (abrConfig.ignoreDevicePixelRatio === true) {
          abr.ignoreDevicePixelRatio = abrConfig.ignoreDevicePixelRatio;
        }
        if (abrConfig.minBitrate && !isNaN(abrConfig.minBitrate)) {
          this.minBitrate = abrConfig.minBitrate;
          restrictions.minBandwidth = abrConfig.minBitrate;
        }
        if (abrConfig.maxBitrate && !isNaN(abrConfig.maxBitrate)) {
          this.maxBitrate = abrConfig.maxBitrate;
          restrictions.maxBandwidth = abrConfig.maxBitrate;
        }
        if (!isNaN(abrConfig.startBitrate)) {
          abr.defaultBandwidthEstimate = abrConfig.startBitrate * 1.15;
        } else {
          abr.defaultBandwidthEstimate = abrConfig.throughputEstimate;
        }
        if (abrConfig.maxHeight && !isNaN(abrConfig.maxHeight)) {
          abr.restrictions.maxHeight = abrConfig.maxHeight;
        }
        abr.restrictToElementSize = abrConfig.capQualityToScreenSize;
        const settings = context2.performanceSettings;
        if (settings.forwardBufferLength != null) {
          playerConfig.streaming.bufferingGoal = settings.forwardBufferLength;
        }
        if (settings.backBufferLength != null) {
          playerConfig.streaming.bufferBehind = settings.backBufferLength;
        }
        if (settings.mode === PerformanceMode.LOW) ;
        this.renderTextTrackNatively = textTrackSettings.native;
        const enableAdvancedCodecs = playback.enableAdvancedCodecs;
        if (playerConfig.restrictions.maxChannelsCount) {
          playerConfig.restrictions.maxChannelsCount = enableAdvancedCodecs ? Infinity : 2;
        }
        playerConfig.preferredVideoCodecs = ["avc"];
        playerConfig.preferredAudioCodecs = ["mp4"];
        if (enableAdvancedCodecs) {
          playerConfig.preferredVideoCodecs = playback.preferredVideoCodecs;
          playerConfig.preferredAudioCodecs = playback.preferredAudioCodecs;
        }
        playerConfig.preferredTextLanguage = textTrackSettings.language;
        playerConfig.preferredAudioLanguage = playerOptions.audioLanguage;
        playerConfig.preferredVariantRole = playerOptions.audioRole;
        if ("preferSpatialAudio" in playerConfig) {
          playerConfig.preferSpatialAudio = playback.preferSpatialAudio || false;
        }
        playerConfig.manifest.hls.useSafariBehaviorForLive = false;
        playerConfig.manifest.dash.disableXlinkProcessing = true;
        const { cmcd } = resource;
        if (cmcd.enabled) {
          playerConfig.cmcd = {
            enabled: true,
            contentId: cmcd.contentId || "",
            sessionId: cmcd.sessionId || "",
            useHeaders: cmcd.useHeaders
          };
        }
        if ((_c = shaka2.text) == null ? void 0 : _c.SimpleTextDisplayer) {
          playerConfig.textDisplayFactory = () => new shaka2.text.SimpleTextDisplayer(this.video, "Shaka Player TextTrack");
        }
        if (options2.flattenCues === true) {
          playerConfig.textDisplayFactory = () => {
            const textDisplayer = new shaka2.text.SimpleTextDisplayer(this.video, "Shaka Player TextTrack");
            const append = textDisplayer.append.bind(textDisplayer);
            const flatten = (cues) => cues.reduce((acc, cue) => {
              if (cue.payload) {
                acc.push(Object.assign({}, cue, { nestedCues: [] }));
              }
              if (cue.nestedCues.length) {
                acc = acc.concat(flatten(cue.nestedCues));
              }
              return acc;
            }, []);
            textDisplayer.append = (cues) => append(flatten(cues));
            return textDisplayer;
          };
        }
        Util.merge(
          playerConfig,
          options2.config
        );
        this.configure();
        const aes = context2.resource.location.drm.aes;
        const needsAes = !Util.isEmpty(aes) && aes.header && aes.provider;
        if (needsAes) {
          this.player.getNetworkingEngine().registerRequestFilter((type, request) => {
            const { RequestType: RequestType2 } = shaka2.net.NetworkingEngine;
            const url = request.uris[0];
            if (type === RequestType2.KEY) {
              url.includes(aes.provider) && Object.assign(request.headers, aes.header);
            }
          });
        }
        if (options2.normalizeHevcCodecs !== false && enableAdvancedCodecs && Util.getResourceMimeType(resource) === MimeType.DASH) {
          context2.player.registerHook(PlayerHookType.RESPONSE, this.responseHook);
        }
        const { RequestType } = shaka2.net.NetworkingEngine;
        function getObjectType(type) {
          let objectType;
          switch (type) {
            case RequestType.MANIFEST:
              objectType = RequestObjectType.MANIFEST;
              break;
            case RequestType.SEGMENT:
              objectType = RequestObjectType.SEGMENT;
              break;
            case RequestType.LICENSE:
            case RequestType.SERVER_CERTIFICATE:
            case RequestType.KEY:
              objectType = RequestObjectType.KEY;
              break;
            default:
              objectType = RequestObjectType.OTHER;
          }
          return objectType;
        }
        this.player.getNetworkingEngine().registerRequestFilter((type, request) => {
          if (!this.delegate.hasHook(PlayerHookType.REQUEST)) {
            return void 0;
          }
          const value = Util.createRequest(request.uris[0], request.headers);
          const metadata = { objectType: getObjectType(type) };
          return this.delegate.applyHook(PlayerHookType.REQUEST, value, metadata).then((value2) => {
            request.uris[0] = value2.url;
            request.headers = value2.headers;
            request.allowCrossSiteCredentials = value2.credentials === "include";
          });
        });
        this.player.getNetworkingEngine().registerResponseFilter((type, response) => {
          if (!this.delegate.hasHook(PlayerHookType.RESPONSE)) {
            return void 0;
          }
          const isManifest = type === shaka2.net.NetworkingEngine.RequestType.MANIFEST;
          let { data } = response;
          if (isManifest) {
            data = this.context.avia.Util.bufferToString(data);
          }
          const metadata = { objectType: getObjectType(type) };
          return this.delegate.applyHook(PlayerHookType.RESPONSE, { url: response.uri, data }, metadata).then((value) => {
            response.uri = value.url;
            response.data = isManifest && typeof TextEncoder !== "undefined" ? new TextEncoder().encode(value.data) : value.data;
          }).catch((e) => {
            console.error(e);
            response.data = data;
          });
        });
      }
      destroy() {
        var _a2, _b;
        (_b = (_a2 = this.playerEventMap.trackschanged).cancel) == null ? void 0 : _b.call(_a2);
        this.removeEvents(this.player, this.playerEventMap);
        clearTimeout(this.textTimeout);
        clearTimeout(this.tracksChangedTimeout);
        this.context.player.removeHook(PlayerHookType.RESPONSE, this.responseHook);
        return this.player.destroy().then(() => {
          this.player = null;
          this.playerConfig = null;
          this.domTextTrack = null;
          if (this.cleanUpVtt) {
            delete window.VTTCue;
          }
          return super.destroy();
        });
      }
      /**
       *
       */
      getId() {
        return SHAKA;
      }
      get info() {
        return {
          id: this.getId(),
          version: shaka2.Player.version
        };
      }
      /**
       *
       */
      load() {
        return super.load().then((metadata) => __async(this, null, function* () {
          var _a2;
          try {
            yield this.player.load(resource.location.mediaUrl, Util.isValidPlayheadTime(startTime) ? startTime : void 0);
            this.isLiveStream = this.player.isLive();
            this.manifestVariants = this.player.getVariantTracks();
            const textTrackUrl = resource.location.textTrackUrl;
            if (!Util.isEmpty(textTrackUrl)) {
              const mime = Util.getMimeType(textTrackUrl);
              yield this.player.addTextTrackAsync(textTrackUrl, "en", TextTrackKind.CAPTIONS, mime);
            }
            this.suppressErrors = false;
            metadata.fragment.mimeType = ((_a2 = this.getActiveVariantTrack()) == null ? void 0 : _a2.mimeType) || "";
            return metadata;
          } catch (error) {
            throw this.createPlayerError(error);
          }
        }));
      }
      /**
       *
       */
      resize() {
        const { abr } = this.playerConfig;
        if (abr.restrictToElementSize === this.qualityCappedToScreenSize) {
          return;
        }
        abr.restrictToElementSize = this.qualityCappedToScreenSize;
        this.configure();
      }
      /**
       *
       */
      suspend() {
        this.playerConfig.streaming.bufferingGoal = 1;
        this.playerConfig.streaming.rebufferingGoal = 1;
        this.configure();
      }
      /**
       *
       */
      resume() {
        this.playerConfig.streaming.bufferingGoal = 10;
        this.playerConfig.streaming.rebufferingGoal = 10;
        this.configure();
      }
      /**
       *
       */
      getIsLiveStream() {
        return this.isLiveStream;
      }
      /**
       *
       */
      clearText() {
        if (this.domTextTrack) {
          Util.clearCue(this.domTextTrack, this.video.currentTime);
        }
      }
      /**
       *
       */
      setMinBitrate(value) {
        super.setMinBitrate(value);
        if (isNaN(value)) {
          value = -Infinity;
        }
        this.playerConfig.restrictions.minBandwidth = value;
        this.configure();
      }
      /**
       *
       */
      setMaxBitrate(value) {
        super.setMaxBitrate(value);
        if (isNaN(value)) {
          value = Infinity;
        }
        const maxAudioBandwidth = this.manifestVariants.reduce((acc, variant) => Math.max(variant.audioBandwidth, acc), 0);
        this.playerConfig.restrictions.maxBandwidth = value + maxAudioBandwidth;
        this.configure();
      }
      /**
       *
       */
      setAutoQualitySwitching(value) {
        this.playerConfig.abr.enabled = value;
        this.configure();
      }
      /**
       *
       */
      setQuality(quality) {
        const track = this.player.getVariantTracks().find((track2) => track2.id === quality.index);
        if (!track) {
          this.logger.warn("Quality track not found, will not set.");
          return;
        }
        this.player.selectVariantTrack(track, true);
      }
      /**
       *
       */
      roleToType(role) {
        return role === "description" || role === "alternate" ? AudioTrackType.DESCRIPTION : AudioTrackType.MAIN;
      }
      /**
       * Private method used for backwards compatibility
       * in place of Shaka's 'getAudioTracks' added in v4.14.0.
       */
      getShakaAudioTracks() {
        const variants = this.manifestVariants;
        const activeVariant = this.getActiveVariantTrack();
        return variants.filter((variant) => variant.originalVideoId === activeVariant.originalVideoId && variant.audioCodec);
      }
      /**
       *
       */
      findShakaTrack(audioTracks, track) {
        return audioTracks.find((t) => t.language === track.language && t.audioCodec === track.codec && t.spatialAudio === track.spatialAudio && this.roleToType(this.getAudioRoles(t.audioRoles)) === track.type);
      }
      /**
       *
       */
      setAudioTrack(track) {
        if (!track) {
          this.logger.info("Audio track is null, will not set.");
          return;
        }
        this.audioSwitching = true;
        const shakaTrack = this.findShakaTrack(this.getShakaAudioTracks(), track);
        this.player.selectVariantTrack(shakaTrack, true, this.safeMargin);
      }
      /**
       *
       */
      setTextTrack(value) {
        var _a2;
        if (!value || value.id === ((_a2 = this.textTrack) == null ? void 0 : _a2.id)) {
          return;
        }
        this.textTrack = value;
        this.delegate.textTrackChange(value);
        this.updateTextTrack();
      }
      /**
       *
       */
      setTextTrackMode(mode) {
        this.updateTextTrack();
        this.delegate.textTrackDisplayModeChange(mode);
      }
      /**
       *
       */
      getMetrics() {
        const variant = this.getActiveVariantTrack();
        const stats = this.player.getStats();
        return {
          droppedVideoFrames: stats.droppedFrames,
          framerate: variant.frameRate || Number.NaN,
          bandwidth: stats.estimatedBandwidth
        };
      }
      /**
       *
       */
      getThumbnails(time) {
        return super.getThumbnails(time).then((thumbnails) => {
          if (this.getIsLiveStream()) {
            const { start, end } = this.player.seekRange();
            time = Util.mapToRange(time, 0, end - start, start, end);
          }
          return Promise.all(this.player.getImageTracks().map((track) => this.player.getThumbnails(track.id, time))).then((thumbs) => {
            thumbs.filter((thumb) => !!thumb).forEach((thumb) => {
              const { width, height, positionX, positionY, uris } = thumb;
              const url = uris[0];
              thumbnails.push({
                x: positionX,
                y: positionY,
                width,
                height,
                url
              });
            });
            return thumbnails;
          });
        });
      }
      /**
       *
       */
      getThroughput() {
        const { estimatedBandwidth } = this.player.getStats();
        return Number.isFinite(estimatedBandwidth) ? estimatedBandwidth : super.getThroughput();
      }
      /**
       *
       */
      getSeekable() {
        return this.player.seekRange();
      }
      /**
       *
       */
      getLiveStreamUtcStart() {
        const relativeMs = (this.getCurrentTime() - this.player.seekRange().start) * 1e3;
        const utc = this.getLiveStreamUtcTime();
        return Math.round(utc - relativeMs);
      }
      /**
       *
       */
      getLiveStreamUtcTime() {
        return this.player.getPlayheadTimeAsDate().getTime();
      }
      /**
       *
       */
      configure() {
        this.player.configure(this.playerConfig);
      }
      /**
       *
       */
      getActiveVariantTrack() {
        return this.player.getVariantTracks().find(isActive) || {};
      }
      /**
       *
       */
      getAudioTrackIndex() {
        const activeTrack = this.getActiveVariantTrack();
        const role = this.roleToType(this.getAudioRoles(activeTrack.audioRoles));
        return this.audioTracks.findIndex((item) => item.language === activeTrack.language && item.type === role && item.spatialAudio === activeTrack.spatialAudio);
      }
      /**
       *
       */
      getAudioTrack() {
        const activeTrack = this.getActiveVariantTrack();
        const role = this.getAudioRoles(activeTrack.audioRoles);
        return { language: activeTrack.language, role, spatialAudio: activeTrack.spatialAudio };
      }
      /**
       *
       */
      getAudioRoles(audioRoles) {
        return (audioRoles == null ? void 0 : audioRoles.join(",")) || "";
      }
      /**
       *
       */
      updateAudioTracks() {
        const audioTracks = this.getShakaAudioTracks();
        let tracks = audioTracks.map((track2, index) => {
          const role = this.getAudioRoles(track2.audioRoles);
          return {
            index,
            id: index.toString(),
            type: this.roleToType(role),
            codec: track2.audioCodec || "",
            language: track2.language,
            label: track2.label || track2.language,
            default: track2.primary,
            spatialAudio: track2.spatialAudio
          };
        });
        tracks = tracks.filter((track2) => !isUnd(track2));
        if (!equal(tracks, this.audioTracks)) {
          this.audioTracks = tracks;
          this.delegate.audioTracksChange(this.audioTracks);
        }
        let track = tracks[this.getAudioTrackIndex()];
        if (isUnd(track)) {
          track = tracks.find((t) => !isUnd(t)) || tracks[0];
        }
        if (!equal(track, this.audioTrack)) {
          this.updateAudioTrack(track);
        }
      }
      /**
       *
       */
      updateAudioTrack(track) {
        this.audioTrack = track;
        this.delegate.audioTrackChange(track);
        this.updateTextTrack();
      }
      /**
       *
       */
      updateTextTrack() {
        var _a2;
        const id = parseInt((_a2 = this.textTrack) == null ? void 0 : _a2.id);
        const tracks = this.player.getTextTracks();
        const track = tracks.find((track2) => track2.id === id);
        const forced = tracks.find((track2) => {
          var _a3;
          return track2.forced && track2.language === ((_a3 = this.audioTrack) == null ? void 0 : _a3.language);
        });
        const selected = textTrackSettings.enabled ? track : forced;
        const visible = textTrackSettings.enabled ? !!track : !!forced;
        if (selected) {
          this.player.selectTextTrack(selected);
        }
        this.player.setTextTrackVisibility(visible);
        if (!this.renderTextTrackNatively && this.domTextTrack) {
          this.textTimeout = setTimeout(() => this.domTextTrack.mode = "hidden", 0);
        }
      }
      /**
       *
       */
      updateTextTracks() {
        const textTracks = this.player.getTextTracks().filter((track) => !track.forced);
        const tracks = textTracks.map((track) => {
          const kind = /subtitle/.test(track.kind) ? TextTrackKind.SUBTITLES : track.kind;
          return {
            id: track.id.toString(),
            language: track.language,
            kind,
            label: track.label || track.language
          };
        });
        if (!equal(tracks, this.textTracks)) {
          this.textTracks = tracks;
          this.delegate.textTracksChange(this.textTracks);
        }
        if (!this.domTextTrack) {
          this.domTextTrack = Array.from(this.video.textTracks).find((textTrack2) => textTrack2.label === "Shaka Player TextTrack");
          if (this.domTextTrack) {
            this.listenToTextTracks(true);
          }
        }
        const textTrack = textTracks.find(isActive);
        const id = textTrack == null ? void 0 : textTrack.id.toString();
        if (!this.textTrack || this.textTrack.id !== id) {
          let track = this.textTracks.find((track2) => track2.id === id);
          if (!track) {
            track = Util.findDefaultTrack(this.textTracks, textTrackSettings.language);
          }
          this.setTextTrack(track);
          return;
        }
        this.player.setTextTrackVisibility(textTrackSettings.enabled);
      }
      updateQualityVariant() {
        if (!this.qualities) {
          return;
        }
        const variant = this.getActiveVariantTrack();
        if (!variant) {
          return;
        }
        const id = variant.id;
        const quality = this.qualities.find((quality2) => quality2.index === id);
        if (quality) {
          this.updateQuality(quality);
        }
      }
      normalizeQuality(track) {
        const { id, bandwidth, width, height, codecs, frameRate } = track;
        return {
          index: id,
          bitrate: bandwidth,
          codec: codecs,
          enabled: true,
          category: [],
          frameRate,
          width,
          height
        };
      }
      /**
       *
       */
      createQualities() {
        if (!this.manifestVariants) {
          return [];
        }
        const audio = this.getAudioTrack();
        return this.manifestVariants.filter(
          (track) => this.getAudioRoles(track.audioRoles) === audio.role && Util.compareLanguageTags(track.language, audio.language) && track.spatialAudio === audio.spatialAudio
        ).map(this.normalizeQuality);
      }
      /**
       *
       */
      refreshQualities() {
        this.updateQualities(this.createQualities());
        if (isFinite(this.maxBitrate)) {
          this.setMaxBitrate(this.maxBitrate);
        }
      }
      /**
       *
       */
      createPlayerError(error) {
        const Error2 = shaka2.util.Error;
        const Category = Error2.Category;
        const Code = Error2.Code;
        const toError = (code, message, cause, fatal = true) => {
          for (const key in Code) {
            const value = Code[key];
            if (value === error.code) {
              message += ` : ${key} / ${value}`;
              break;
            }
          }
          return this.createError(code, message, cause, fatal);
        };
        switch (error.category) {
          case Category.NETWORK:
            return toError(ErrorCode.SHAKA_NETWORK_ERROR, ErrorMessage.FATAL_PLAYBACK_NETWORK_ERROR, error);
          case Category.MANIFEST:
            return toError(ErrorCode.SHAKA_PARSE_ERROR, ErrorMessage.FATAL_PLAYBACK_MEDIA_ERROR, error);
          case Category.MEDIA:
            const code = error.code === Code.VIDEO_ERROR && error.data[0] === MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED ? ErrorCode.SHAKA_SRC_NOT_SUPPORTED : ErrorCode.SHAKA_MEDIA_ERROR;
            return toError(code, ErrorMessage.FATAL_PLAYBACK_MEDIA_ERROR, error);
          case Category.DRM:
            return toError(ErrorCode.SHAKA_DRM_ERROR, ErrorMessage.FATAL_PLAYBACK_MEDIA_ERROR, error);
          default:
            return toError(ErrorCode.UNSPECIFIED_SHAKA_ERROR, ErrorMessage.UNSPECIFIED_ERROR, error, false);
        }
      }
      onCueChange(event) {
        const track = this.player.getTextTracks().find((track2) => track2.active);
        if (!track) {
          return;
        }
        super.onCueChange(event, track.forced);
      }
      /**
       *
       */
      onError(e) {
        const { code, message, cause, fatal } = this.createPlayerError(e.detail);
        this.throwError(code, message, cause, fatal);
      }
      /**
       *
       */
      onStreaming() {
        this.segmentDuration = this.player.getStats().maxSegmentDuration;
      }
      onManifestUpdated(event) {
        return __async(this, null, function* () {
          var _a2;
          const mimeType = Util.getResourceMimeType(resource);
          const isHls = mimeType === avia.MimeType.HLS || mimeType === avia.MimeType.HLS_ALT;
          if (event.isLive || isHls || ((_a2 = resource.overrides) == null ? void 0 : _a2.skipLiveToVodManifestUpdate)) {
            return;
          }
          const { relativeTime, relativeDuration } = this.liveStreamInfo;
          playback.startTime = relativeTime / relativeDuration * this.getSeekable().end;
          this.isLiveStream = false;
          yield this.load();
          this.video.play();
        });
      }
      /**
       *
       */
      onVariantChanged() {
        if (this.audioSwitching) {
          this.audioSwitching = false;
          const { language, role, spatialAudio } = this.getAudioTrack();
          const type = this.roleToType(role);
          const audioTrack = this.audioTracks.find((track) => track.language === language && track.type === type && track.spatialAudio === spatialAudio);
          this.updateAudioTrack(audioTrack);
          return;
        }
        if (this.qualities == null) {
          return;
        }
        this.refreshQualities();
        this.updateQualityVariant();
      }
      /**
       *
       */
      onTracksChanged() {
        if (!this.player || !this.manifestVariants) {
          return;
        }
        this.updateAudioTracks();
        this.updateTextTracks();
        this.refreshQualities();
        if (!this.quality) {
          this.updateQualityVariant();
        }
      }
      /**
       *
       */
      onDrmSessionUpdate() {
        this.delegate.drmKeySystemCreated(this.player.keySystem());
      }
      /**
       *
       */
      onEmsg(event) {
        const emsg = event.detail;
        const { schemeIdUri, messageData, startTime: startTime2, endTime, value } = emsg || {};
        const { emsgAltId3SchemeIdUris } = playerOptions.overrides || {};
        if (emsg.schemeIdUri === "https://aomedia.org/emsg/ID3" && !this.useId3TimingCompensation) {
          return;
        } else if (this.useId3TimingCompensation || (emsgAltId3SchemeIdUris == null ? void 0 : emsgAltId3SchemeIdUris.includes(schemeIdUri))) {
          const frames = avia.id3.getId3Frames(messageData);
          frames.forEach((frame) => {
            this.metadataSurface.addId3Metadata(frame.key, {
              id: event.id,
              startTime: startTime2,
              endTime: startTime2 + (emsg.duration || 0),
              source: emsg,
              data: frame.data,
              info: frame.info,
              text: frame.info
            });
          });
          return;
        }
        this.delegate.metadataCuepoint({
          id: schemeIdUri,
          info: value,
          text: value,
          data: messageData,
          source: emsg,
          startTime: startTime2,
          endTime
        });
      }
      /**
       *
       */
      onMetadata(event) {
        if (this.useId3TimingCompensation) {
          return;
        }
        const { payload } = event;
        const { description, data } = payload;
        this.metadataSurface.addId3Metadata(payload.key, {
          id: "",
          info: description,
          text: data,
          data,
          source: event,
          startTime: event.startTime,
          endTime: event.endTime
        });
      }
      /**
       *
       */
      onTimelineRegionEnter(event) {
        var _a2, _b;
        if (this.video.seeking) {
          return;
        }
        const info = event.detail;
        const { startTime: startTime2, endTime, schemeIdUri, value, eventNode, eventElement } = info;
        let messageData;
        if (eventNode) {
          messageData = (_a2 = eventNode.attributes) == null ? void 0 : _a2.messageData;
        } else if (eventElement == null ? void 0 : eventElement.getAttribute) {
          try {
            messageData = eventElement.getAttribute("messageData");
          } catch (e) {
            this.logger.warn("Unable to obtain messageData from TimelineRegionInfo.eventElement");
          }
        }
        const txt = value || messageData;
        const data = messageData;
        const isCached = (_b = this.cachedCuepoints) == null ? void 0 : _b.find((e) => {
          return e.id === schemeIdUri && e.startTime === startTime2 && e.endTime === endTime && e.data === data;
        });
        if (isCached) {
          return;
        }
        this.delegate.metadataCuepoint({
          id: schemeIdUri,
          info: txt,
          text: txt,
          data,
          source: info,
          startTime: startTime2,
          endTime
        });
      }
      // aviajs-1050: Pending a fix in shaka, avoid loss of default ad impression.
      onTimeUpdate() {
        var _a2;
        if ((_a2 = this.cachedCuepoints) == null ? void 0 : _a2.find((q) => !q.emitted)) {
          const t = this.video.currentTime;
          this.cachedCuepoints.forEach((q) => {
            if (!q.emitted && t >= q.startTime) {
              const out = __spreadValues({}, q);
              q.emitted = true;
              this.delegate.metadataCuepoint(out);
            }
          });
        }
        super.onTimeUpdate();
      }
    }
    return new ShakaAdapter(context, options);
  });
}
function createShakaPlugin(services, options) {
  const { avia, logger, player } = services;
  if (typeof TextDecoder === "undefined") {
    logger.warn("Polyfill warning: TextDecoder is not defined");
  }
  player.registerAdapter({
    id: SHAKA,
    role: [avia.AdapterRole.PLAYBACK],
    options,
    factory: createShakaAdapter,
    isSupported: isShakaSupported
  });
  return {
    getId() {
      return SHAKA;
    },
    destroy() {
    }
  };
}
function shaka(options = {}) {
  return {
    id: SHAKA,
    factory: createShakaPlugin,
    options
  };
}
const DASH = "dash";
function createDashPlugin(services, options = {}) {
  const createOptions = (id) => {
    var _a;
    const opts = (_a = options.adapter) == null ? void 0 : _a[id];
    const dependencies = options.dependencies || {};
    return Object.assign({ debug: options.debug }, opts, { dependencies });
  };
  const plugins = [
    createShakaPlugin(services, createOptions(SHAKA))
  ];
  return {
    getId() {
      return DASH;
    },
    destroy() {
      plugins.map((plugin2) => {
        var _a;
        return (_a = plugin2.destroy) == null ? void 0 : _a.call(plugin2);
      });
    }
  };
}
function dash(options = {}) {
  return {
    id: DASH,
    factory: createDashPlugin,
    options
  };
}
const ID = DASH;
const createPlugin = createDashPlugin;
const plugin = dash;
exports.DASH = DASH;
exports.ID = ID;
exports.SHAKA = SHAKA;
exports.createDashPlugin = createDashPlugin;
exports.createPlugin = createPlugin;
exports.createShakaAdapter = createShakaAdapter;
exports.createShakaPlugin = createShakaPlugin;
exports.dash = dash;
exports.plugin = plugin;
exports.shaka = shaka;
//# sourceMappingURL=avia.dash.cjs.map
